import React, { useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  IconButton,
  Divider,
  Slider,
  ToggleButton,
  ToggleButtonGroup,
  Chip,
  TextField,
  MenuItem,
  Paper,
  Autocomplete,
} from "@mui/material";
import { CleaningServices, Close, Search } from "@mui/icons-material";
import { useProperty } from "../../context/PropertyContext";
import {
  Home,
  Apartment,
  BedroomParent,
  Landscape,
  HolidayVillage,
  Business,
  LocationCity,
  Gite,
  Store,
  Fence,
  NightShelter,
  CorporateFare,
  MapsHomeWork,
  EmojiTransportation,
  House,
  AccountBalance,
  Bungalow,
  Storefront,
  LocalConvenienceStore,
  StoreMallDirectory,
  Wifi as WifiIcon,
  Tv as TvIcon,
  Kitchen as FridgeIcon,
  Microwave as MicrowaveIcon,
  OutdoorGrill as OutdoorGrillIcon,
  Bathroom as BathroomIcon,
  LocalLaundryService as LocalLaundryServiceIcon,
  Water as WaterIcon,
  FlashOn as FlashOnIcon,
  CleaningServices as CleaningServicesIcon,
  School as SchoolIcon,
  Landscape as LandscapeIcon,
  Pool as PoolIcon,
  LocalParking as ParkingIcon,
  LocalPolice as LocalPoliceIcon,
  Park as ParkIcon,
  Attractions as AttractionsIcon,
  FitnessCenter as FitnessCenterIcon,
  AcUnit as AcUnitIcon,
  FreeBreakfast as FreeBreakfastIcon,
  TableRestaurant as TableRestaurantIcon,
  Checkroom as CheckroomIcon,
} from "@mui/icons-material";
import { costaRicaData } from "../../utils/cr_address/provincias_cantones_distritos_costa_rica";

interface PropertyFilterModalProps {
  open: boolean;
  onClose: () => void;
  sx?: object;
}

const categories = [
  { name: "Casa", icon: <Home sx={{ fontSize: 30 }} /> },
  { name: "Apartamento", icon: <Apartment sx={{ fontSize: 30 }} /> },
  { name: "Habitación", icon: <BedroomParent sx={{ fontSize: 30 }} /> },
  { name: "Lote", icon: <Landscape sx={{ fontSize: 30 }} /> },
  { name: "Condominio", icon: <HolidayVillage sx={{ fontSize: 30 }} /> },
  { name: "Edificio", icon: <Business sx={{ fontSize: 30 }} /> },
  { name: "Torre", icon: <LocationCity sx={{ fontSize: 30 }} /> },
  { name: "Finca", icon: <Gite sx={{ fontSize: 30 }} /> },
  { name: "Local", icon: <Store sx={{ fontSize: 30 }} /> },
  { name: "Terreno", icon: <Fence sx={{ fontSize: 30 }} /> },
  { name: "Casa independiente", icon: <NightShelter sx={{ fontSize: 30 }} /> },
  { name: "Penthouse", icon: <CorporateFare sx={{ fontSize: 30 }} /> },
  { name: "Townhouse", icon: <Apartment sx={{ fontSize: 30 }} /> },
  { name: "Apartamento loft", icon: <MapsHomeWork sx={{ fontSize: 30 }} /> },
  {
    name: "Apartamento estudio",
    icon: <EmojiTransportation sx={{ fontSize: 30 }} />,
  },
  { name: "Casa de lujo", icon: <House sx={{ fontSize: 30 }} /> },
  { name: "Moderna", icon: <AccountBalance sx={{ fontSize: 30 }} /> },
  { name: "Rústica", icon: <Bungalow sx={{ fontSize: 30 }} /> },
  { name: "Propiedad Comercial", icon: <Storefront sx={{ fontSize: 30 }} /> },
  { name: "Oficentro", icon: <LocalConvenienceStore sx={{ fontSize: 30 }} /> },
  { name: "Mall", icon: <StoreMallDirectory sx={{ fontSize: 30 }} /> },
];

const services = [
  { id: "wifi", icon: <WifiIcon />, label: "Wi-Fi" },
  { id: "tv", icon: <TvIcon />, label: "Televisión" },
  { id: "nevera", icon: <FridgeIcon />, label: "Nevera" },
  { id: "microondas", icon: <MicrowaveIcon />, label: "Microondas" },
  { id: "estufa", icon: <OutdoorGrillIcon />, label: "Estufa" },
  {
    id: "calentador de agua",
    icon: <BathroomIcon />,
    label: "Calentador de agua",
  },
  { id: "lavadora", icon: <LocalLaundryServiceIcon />, label: "Lavadora" },
  { id: "secadora", icon: <LocalLaundryServiceIcon />, label: "Secadora" },
  { id: "agua", icon: <WaterIcon />, label: "Agua" },
  { id: "electricidad", icon: <FlashOnIcon />, label: "Electricidad" },
  { id: "limpieza", icon: <CleaningServicesIcon />, label: "Limpieza" },
];

const amenities = [
  {
    id: "cerca de la escuela",
    icon: <SchoolIcon />,
    label: "Cerca de la Escuela",
  },
  {
    id: "vista a las montañas",
    icon: <LandscapeIcon />,
    label: "Vista a las Montañas",
  },
  { id: "piscina", icon: <PoolIcon />, label: "Piscina" },
  {
    id: "parking de visitas",
    icon: <ParkingIcon />,
    label: "Parking de Visitas",
  },
  {
    id: "seguridad 24 horas",
    icon: <LocalPoliceIcon />,
    label: "Seguridad 24 Horas",
  },
  { id: "jardín o parque", icon: <ParkIcon />, label: "Jardín o Parque" },
  {
    id: "parque infantil",
    icon: <AttractionsIcon />,
    label: "Parque Infantil",
  },
  { id: "gimnasio", icon: <FitnessCenterIcon />, label: "Gimnasio" },
  { id: "estacionamiento", icon: <ParkingIcon />, label: "Estacionamiento" },
  {
    id: "aire acondicionado",
    icon: <AcUnitIcon />,
    label: "Aire Acondicionado",
  },
  { id: "desayunador", icon: <FreeBreakfastIcon />, label: "Desayunador" },
  {
    id: "sala y comedor",
    icon: <TableRestaurantIcon />,
    label: "Sala y Comedor",
  },
  { id: "Walk-in-closet", icon: <CheckroomIcon />, label: "Walk-In-Closet" },
];

const publicationDateOptions = [
  { label: "Todas", value: "all" },
  { label: "Ultimas 24 horas", value: "last24hours" },
  { label: "Ultimos 3 días", value: "last3days" },
  { label: "Ultima semana", value: "last7days" },
  { label: "Ultimo mes", value: "last30days" },
];

const PropertyFilterModal: React.FC<PropertyFilterModalProps> = ({
  open,
  onClose,
}) => {
  const [transactionType, setTransactionType] = useState<string>("Todos");
  const [priceRange, setPriceRange] = useState<[number, number]>([
    50, 500000000,
  ]);
  const [selectedProvincia, setSelectedProvincia] = useState("");
  const [selectedCanton, setSelectedCanton] = useState("");
  const [selectedDistrito, setSelectedDistrito] = useState("");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [selectedAmenities, setSelectedAmenities] = useState<string[]>([]);
  const [selectedPublicationDate, setSelectedPublicationDate] = useState("all");
  const [currency, setCurrency] = useState("all");
  const [query, setQuery] = useState("");
  const { filterProperties } = useProperty();

  const handlePriceChange = (event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue) && newValue.length === 2) {
      setPriceRange([newValue[0], newValue[1]]);
    }
  };

  const handleTransactionTypeChange = (
    event: React.MouseEvent<HTMLElement>,
    newTransactionType: string | null
  ) => {
    if (newTransactionType !== null) {
      setTransactionType(newTransactionType);
    }
  };

  const toggleService = (id: string) =>
    setSelectedServices((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  const toggleAmenity = (id: string) =>
    setSelectedAmenities((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id]
    );

  const clearFilters = () => {
    setTransactionType("Todos");
    setPriceRange([50, 500000000]);
    setSelectedCategories([]);
    setSelectedServices([]);
    setSelectedAmenities([]);
    setSelectedProvincia("");
    setSelectedCanton("");
    setSelectedDistrito("");
    setSelectedPublicationDate("all");
    setCurrency("all");
    setQuery("");
  };

  const handleApplyFilters = () => {
    filterProperties({
      transactionType,
      priceRange,
      selectedCategories,
      selectedServices,
      selectedAmenities,
      currency,
      selectedProvince: provinciaNombre,
      selectedCanton: cantonNombre,
      selectedDistrito: distritoNombre,
      query,
      selectedPublicationDate,
    });
    onClose();
  };

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("es-CR", {
      style: "currency",
      currency: "CRC",
      minimumFractionDigits: 0,
    }).format(price);
  };

  const handleToggleCategory = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const provinciasList = Object.entries(costaRicaData.provincias).map(
    ([id, { nombre }]) => ({
      id,
      nombre,
    })
  );

  const cantonesList = selectedProvincia
    ? Object.entries(
        costaRicaData.provincias[
          selectedProvincia as keyof typeof costaRicaData.provincias
        ]?.cantones || {}
      ).map(([id, { nombre }]) => ({ id, nombre }))
    : [];

  const distritosList =
    selectedProvincia && selectedCanton
      ? Object.entries(
          costaRicaData.provincias[
            selectedProvincia as keyof typeof costaRicaData.provincias
          ]?.cantones[
            selectedCanton as keyof (typeof costaRicaData.provincias)[keyof typeof costaRicaData.provincias]["cantones"]
          ]?.distritos || {}
        ).map(([id, nombre]) => ({ id, nombre }))
      : [];

  const provinciaNombre = selectedProvincia
    ? costaRicaData.provincias[
        selectedProvincia as keyof typeof costaRicaData.provincias
      ]?.nombre
    : undefined;
  const cantonNombre =
    selectedProvincia && selectedCanton
      ? costaRicaData.provincias[
          selectedProvincia as keyof typeof costaRicaData.provincias
        ]?.cantones[
          selectedCanton as keyof (typeof costaRicaData.provincias)[keyof typeof costaRicaData.provincias]["cantones"]
        ]?.nombre
      : undefined;
  const distritoNombre =
    selectedProvincia && selectedCanton && selectedDistrito
      ? costaRicaData.provincias[
          selectedProvincia as keyof typeof costaRicaData.provincias
        ]?.cantones[
          selectedCanton as keyof (typeof costaRicaData.provincias)[keyof typeof costaRicaData.provincias]["cantones"]
        ]?.distritos[
          selectedDistrito as keyof (typeof costaRicaData.provincias)[keyof typeof costaRicaData.provincias]["cantones"][keyof (typeof costaRicaData.provincias)[keyof typeof costaRicaData.provincias]["cantones"]]["distritos"]
        ]
      : undefined;

  return (
  <Modal 
    open={open} 
    onClose={onClose} 
    keepMounted={true}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: "90%",
        maxWidth: 600,
        maxHeight: "85vh",
        bgcolor: "background.paper",
        borderRadius: 4,
        boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transform: open ? "scale(1)" : "scale(0.9)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        opacity: open ? 1 : 0,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2.5,
          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <Typography
          variant="h6"
          sx={{ 
            flexGrow: 1, 
            fontWeight: 600, 
            textAlign: "center",
            fontSize: "1.1rem",
            color: "#2d3748"
          }}
        >
          Búsqueda avanzada
        </Typography>
        <IconButton 
          onClick={onClose}
          sx={{
            bgcolor: "rgba(0,0,0,0.04)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.08)" },
            borderRadius: 2
          }}
        >
          <Close sx={{ fontSize: 20 }} />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ p: 2.5, flex: 1, overflowY: "auto" }}>
        {/* Transacción */}
        <Typography 
          variant="subtitle2" 
          sx={{ 
            mb: 1.5, 
            fontWeight: 600, 
            fontSize: "0.85rem",
            color: "#4a5568"
          }}
        >
          Tipo de Publicación
        </Typography>
        <ToggleButtonGroup
          color="success"
          value={transactionType}
          exclusive
          onChange={handleTransactionTypeChange}
          fullWidth
          size="small"
          sx={{
            "& .MuiToggleButton-root": {
              borderRadius: "12px",
              fontSize: "0.8rem",
              fontWeight: 500,
              textTransform: "none",
              py: 0.8,
              "&.Mui-selected": {
                background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
                color: "white",
                "&:hover": {
                  background: "linear-gradient(135deg, #38a169 0%, #2f855a 100%)",
                }
              }
            }
          }}
        >
          <ToggleButton value="Todos">Todos</ToggleButton>
          <ToggleButton value="Alquiler">Alquiler</ToggleButton>
          <ToggleButton value="Venta">Venta</ToggleButton>
        </ToggleButtonGroup>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Categorías */}
        <Box sx={{ mt: 2.5 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              fontSize: "0.85rem",
              color: "#4a5568"
            }}
          >
            Categorías
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {categories.map((cat) => {
              const isSelected = selectedCategories.includes(cat.name);
              return (
                <Chip
                  key={cat.name}
                  label={
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      {cat.icon}
                      <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                        {cat.name}
                      </Typography>
                    </Box>
                  }
                  onClick={() => handleToggleCategory(cat.name)}
                  variant={isSelected ? "filled" : "outlined"}
                  sx={{
                    borderRadius: "16px",
                    px: 1.5,
                    py: 0.5,
                    height: 32,
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    ...(isSelected ? {
                      background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
                      color: "white",
                      border: "none",
                      "&:hover": {
                        background: "linear-gradient(135deg, #38a169 0%, #2f855a 100%)",
                      }
                    } : {
                      borderColor: "rgba(0,0,0,0.12)",
                      "&:hover": {
                        borderColor: "#48bb78",
                        bgcolor: "rgba(72, 187, 120, 0.04)"
                      }
                    })
                  }}
                />
              );
            })}
          </Box>
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Ubicación */}
        <Box sx={{ mt: 2.5 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              fontSize: "0.85rem",
              color: "#4a5568"
            }}
          >
            Ubicación
          </Typography>

          <Box sx={{ display: "flex", gap: 1.5, mb: 1.5 }}>
            <Autocomplete
              options={provinciasList}
              getOptionLabel={(option) => option.nombre}
              value={provinciasList.find(prov => prov.id === selectedProvincia) || null}
              onChange={(event, newValue) => {
                setSelectedProvincia(newValue ? newValue.id : "");
                setSelectedCanton("");
                setSelectedDistrito("");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provincia"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      fontSize: "0.8rem"
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem"
                    }
                  }}
                />
              )}
              size="small"
              fullWidth
              filterOptions={(options, { inputValue }) => {
                return options.filter(option =>
                  option.nombre.toLowerCase().includes(inputValue.toLowerCase())
                );
              }}
              PaperComponent={({ children, ...props }) => (
                <Paper
                  {...props}
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    "& .MuiAutocomplete-option": {
                      fontSize: "0.8rem",
                      py: 0.8
                    }
                  }}
                >
                  {children}
                </Paper>
              )}
            />

            <Autocomplete
              options={cantonesList}
              getOptionLabel={(option) => option.nombre}
              value={cantonesList.find(canton => canton.id === selectedCanton) || null}
              onChange={(event, newValue) => {
                setSelectedCanton(newValue ? newValue.id : "");
                setSelectedDistrito("");
              }}
              disabled={!selectedProvincia}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cantón"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      fontSize: "0.8rem"
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.8rem"
                    }
                  }}
                />
              )}
              size="small"
              fullWidth
              filterOptions={(options, { inputValue }) => {
                return options.filter(option =>
                  option.nombre.toLowerCase().includes(inputValue.toLowerCase())
                );
              }}
              PaperComponent={({ children, ...props }) => (
                <Paper
                  {...props}
                  sx={{
                    borderRadius: "12px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    "& .MuiAutocomplete-option": {
                      fontSize: "0.8rem",
                      py: 0.8
                    }
                  }}
                >
                  {children}
                </Paper>
              )}
            />
          </Box>

          <Autocomplete
            options={distritosList}
            getOptionLabel={(option) => option.nombre}
            value={distritosList.find(distrito => distrito.id === selectedDistrito) || null}
            onChange={(event, newValue) => {
              setSelectedDistrito(newValue ? newValue.id : "");
            }}
            disabled={!selectedCanton}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Distrito"
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    fontSize: "0.8rem"
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.8rem"
                  }
                }}
              />
            )}
            size="small"
            fullWidth
            filterOptions={(options, { inputValue }) => {
              return options.filter(option =>
                option.nombre.toLowerCase().includes(inputValue.toLowerCase())
              );
            }}
            PaperComponent={({ children, ...props }) => (
              <Paper
                {...props}
                sx={{
                  borderRadius: "12px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                  "& .MuiAutocomplete-option": {
                    fontSize: "0.8rem",
                    py: 0.8
                  }
                }}
              >
                {children}
              </Paper>
            )}
          />
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Query */}
        <Box>
          <TextField
            type="text"
            fullWidth
            size="small"
            placeholder="¿Qué buscas en especial?"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                fontSize: "0.85rem",
                "&:hover fieldset": {
                  borderColor: "#48bb78"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#48bb78"
                }
              },
              "& .MuiInputBase-input": {
                fontSize: "0.85rem"
              }
            }}
          />
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Moneda */}
        <Box sx={{ mt: 2.5 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              fontSize: "0.85rem",
              color: "#4a5568"
            }}
          >
            Moneda
          </Typography>
          <TextField
            select
            size="small"
            fullWidth
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                fontSize: "0.8rem"
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.8rem"
              }
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    borderRadius: "12px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
                  }
                }
              }
            }}
          >
            <MenuItem value="all" sx={{ fontSize: "0.8rem", py: 0.8 }}>
              Todas
            </MenuItem>
            <MenuItem value="CRC" sx={{ fontSize: "0.8rem", py: 0.8 }}>
              ₡ Colones
            </MenuItem>
            <MenuItem value="USD" sx={{ fontSize: "0.8rem", py: 0.8 }}>
              $ Dólares
            </MenuItem>
          </TextField>
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Precio */}
        <Typography 
          variant="subtitle2" 
          sx={{ 
            mb: 1.5, 
            fontWeight: 600, 
            fontSize: "0.85rem",
            color: "#4a5568"
          }}
        >
          Rango de Precios
        </Typography>
        <Slider
          value={priceRange}
          onChange={handlePriceChange}
          valueLabelDisplay="auto"
          min={5000}
          max={500000000}
          step={1000}
          color="success"
          sx={{
            "& .MuiSlider-thumb": {
              boxShadow: "0 2px 8px rgba(72, 187, 120, 0.3)"
            },
            "& .MuiSlider-track": {
              background: "linear-gradient(90deg, #48bb78 0%, #38a169 100%)"
            }
          }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.75rem",
            color: "#718096",
            fontWeight: 500
          }}
        >
          <span>Min: {formatPrice(priceRange[0])}</span>
          <span>Max: {formatPrice(priceRange[1])}</span>
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Servicios */}
        <Box sx={{ mt: 2.5 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              fontSize: "0.85rem",
              color: "#4a5568"
            }}
          >
            Servicios
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {services.map((s) => {
              const isSelected = selectedServices.includes(s.id);
              return (
                <Chip
                  key={s.id}
                  label={
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      {s.icon}
                      <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                        {s.label}
                      </Typography>
                    </Box>
                  }
                  onClick={() => toggleService(s.id)}
                  variant={isSelected ? "filled" : "outlined"}
                  sx={{
                    borderRadius: "16px",
                    px: 1.5,
                    py: 0.5,
                    height: 32,
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    ...(isSelected ? {
                      background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
                      color: "white",
                      border: "none",
                      "&:hover": {
                        background: "linear-gradient(135deg, #38a169 0%, #2f855a 100%)",
                      }
                    } : {
                      borderColor: "rgba(0,0,0,0.12)",
                      "&:hover": {
                        borderColor: "#48bb78",
                        bgcolor: "rgba(72, 187, 120, 0.04)"
                      }
                    })
                  }}
                />
              );
            })}
          </Box>
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />

        {/* Amenidades */}
        <Box sx={{ mt: 2.5 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              fontSize: "0.85rem",
              color: "#4a5568"
            }}
          >
            Amenidades
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {amenities.map((a) => {
              const isSelected = selectedAmenities.includes(a.id);
              return (
                <Chip
                  key={a.id}
                  label={
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      {a.icon}
                      <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                        {a.label}
                      </Typography>
                    </Box>
                  }
                  onClick={() => toggleAmenity(a.id)}
                  variant={isSelected ? "filled" : "outlined"}
                  sx={{
                    borderRadius: "16px",
                    px: 1.5,
                    py: 0.5,
                    height: 32,
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    ...(isSelected ? {
                      background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
                      color: "white",
                      border: "none",
                      "&:hover": {
                        background: "linear-gradient(135deg, #38a169 0%, #2f855a 100%)",
                      }
                    } : {
                      borderColor: "rgba(0,0,0,0.12)",
                      "&:hover": {
                        borderColor: "#48bb78",
                        bgcolor: "rgba(72, 187, 120, 0.04)"
                      }
                    })
                  }}
                />
              );
            })}
          </Box>
        </Box>

        <Divider sx={{ my: 2.5, borderColor: "rgba(0,0,0,0.06)" }} />


        {/* Fecha de publicación */}
        <Box sx={{ mt: 2.5 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              mb: 1.5, 
              fontWeight: 600, 
              fontSize: "0.85rem",
              color: "#4a5568"
            }}
          >
            Fecha de publicación
          </Typography>
          <TextField
            select
            fullWidth
            size="small"
            value={selectedPublicationDate}
            onChange={(e) => setSelectedPublicationDate(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                fontSize: "0.8rem"
              }
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    borderRadius: "12px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)"
                  }
                }
              }
            }}
          >
            {publicationDateOptions.map((option) => (
              <MenuItem 
                key={option.value} 
                value={option.value}
                sx={{ fontSize: "0.8rem", py: 0.8 }}
              >
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>

      {/* Footer */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          p: 2.5,
          borderTop: "1px solid rgba(0,0,0,0.06)",
          background: "rgba(248, 249, 250, 0.5)"
        }}
      >
        <Button
          onClick={clearFilters}
          variant="outlined"
          startIcon={<CleaningServices sx={{ fontSize: "1rem" }} />}
          sx={{
            borderRadius: "12px",
            px: 2.5,
            py: 1,
            fontSize: "0.8rem",
            fontWeight: 600,
            textTransform: "none",
            borderColor: "rgba(0,0,0,0.12)",
            color: "#4a5568",
            "&:hover": {
              borderColor: "#e53e3e",
              color: "#e53e3e",
              bgcolor: "rgba(229, 62, 62, 0.04)"
            }
          }}
        >
          Limpiar
        </Button>
        <Button
          onClick={handleApplyFilters}
          variant="contained"
          startIcon={<Search sx={{ fontSize: "1rem" }} />}
          sx={{
            borderRadius: "12px",
            px: 2.5,
            py: 1,
            fontSize: "0.8rem",
            fontWeight: 600,
            textTransform: "none",
            background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
            boxShadow: "0 4px 12px rgba(72, 187, 120, 0.3)",
            "&:hover": {
              background: "linear-gradient(135deg, #38a169 0%, #2f855a 100%)",
              boxShadow: "0 6px 16px rgba(72, 187, 120, 0.4)"
            }
          }}
        >
          Buscar
        </Button>
      </Box>
    </Box>
  </Modal>
);
};

export default PropertyFilterModal;
